<template>
  <div>
    <div class="container text-center mb-5">
        <h1 class="bold300 text-uppercase" style=" font-weight:500;">Secretaria de Hacienda</h1>
    </div>
      <nav>
        <div class="nav nav-movil nav-tabs" id="nav-tab" role="tablist">
            <a
                class="nav-link"
                @click="itemActive1 = true, itemActive2 = false, itemActive3 = false"
                :class="[
                  (!modoDark_var && itemActive1 && !itemActive2)? 'active' : '',
                  (modoDark_var && itemActive1 && !itemActive2)? 'DarkActive active' : '',
                  (modoDark_var && itemActive1==false && (itemActive2))? 'darkInactivo' : ''
                ]"
                id="nav-normContable-tab"
                data-toggle="tab"
                href="#nav-normContable"
                role="tab"
                aria-controls="nav-normContable"
                aria-selected="true"
                > <span class="verPc"><p class="m-0">Armonización Contable</p></span><span class="verMovil"><p class="m-0">Contable</p></span>
            </a>
            <a
                class="nav-link"
                @click="itemActive1 = false, itemActive2 = true, itemActive3 = false"
                :class="[
                  (!modoDark_var && itemActive2 && !itemActive1)? 'active' : '',
                  (modoDark_var && itemActive2 && !itemActive1)? 'DarkActive active' : '',
                  (modoDark_var && itemActive2==false && (itemActive1))? 'darkInactivo' : ''
                ]"
                id="nav-normFinanciera-tab"
                data-toggle="tab"
                href="#nav-normFinanciera"
                role="tab"
                aria-controls="nav-normFinanciera"
                aria-selected="false"
                >
                <span class="verPc"><p class="m-0">Ley de Disciplina Financiera</p></span><span class="verMovil"><p class="m-0">Financiera</p></span>
            </a>
            <a
              class="nav-link"
              @click="itemActive1 = false, itemActive2 = false, itemActive3 = true"
              :class="[
                  (!modoDark_var && itemActive3 && !itemActive1 && !itemActive2)? 'active' : '',
                  (modoDark_var && itemActive3 && !itemActive1 && !itemActive2)? 'DarkActive active' : '',
                  (modoDark_var && itemActive3==false && (itemActive1 || itemActive2))? 'darkInactivo' : ''
              ]"
              id="nav-anexos-tab"
              data-toggle="tab"
              href="#nav-anexos"
              role="tab"
              aria-controls="nav-anexos-tab"
              aria-selected="false"
              >
              <span class="verPc"><p class="m-0">Anexos disiplina financiera</p></span><span class="verMovil"><p class="m-0">Anexos</p></span>
          </a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
          <div :class="[(itemActive1 && !itemActive2 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-normContable" role="tabpanel" aria-labelledby="nav-normContable-tab">

              <div class="card">
                  <div class="card-body">
                      <div class="row card-body">
                          <div class="container text-left mb-3">
                              <h6>Armonización Contable</h6>
                          </div>
                          <select2Filtros id="selectFiltro1SH"  placeholder1="Seleccionar Opción" placeholder2="Seleccione año" :data="data" @seleccionado="responseSelectComponent = $event" @titulo="textoTitulo = $event" />
                      </div>
                  </div>
              </div>
              <!-- componente aqui -->
            <tabla-simple id="tabla1Filtros" class="mt-5" :titulo="textoTitulo" :datos="responseSelectComponent" />
            <span v-if="responseSelectComponent" v-html="DateFormatText(responseSelectComponent.fecha_actualizacion)"></span>
            <span v-else v-html="DateFormatText(fecha_actualizacion_externa)"></span>
          </div>
          <div :class="[(itemActive2 && !itemActive1 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-normFinanciera" role="tabpanel" aria-labelledby="nav-normFinanciera-tab">
            <div class="card">
              <div class="card-body">
                <div class="row card-body">
                  <div class="container text-left mb-3">
                      <h6>Información de la Ley de Disciplina Financiera</h6>
                  </div>
                  <select2Filtros id="selectDisFinancieraSH" placeholder1="Seleccione año" placeholder2="Seleccione el trimestre" :data="disFinanciera" @seleccionado="responseSelectComponent2 = $event" @titulo="textoTitulo2 = $event" />
                </div>
              </div>
            </div>
            <!-- aqui puede estar tu componente, o tu info -->
            <tabla-simple class="mt-5" :titulo="`Información de la Ley de Disciplina Financiera ${textoTitulo2} `" :datos="responseSelectComponent2" />
            <span v-if="responseSelectComponent2" v-html="DateFormatText(responseSelectComponent2.fecha_actualizacion)"></span>
            <span v-else v-html="DateFormatText(fecha_actualizacion_externa2)"></span>
          </div>
          <div :class="[(itemActive3 && !itemActive1 && !itemActive2)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-anexos" role="tabpanel" aria-labelledby="nav-anexos-tab">
          <div class="card">
              <div class="card-body">
                  <div class="row card-body">
                    <div class="container text-left mb-3">
                      <h6>Anexos de la Ley de Disciplina Financiera</h6>
                  </div>
                  <select2Filtros id="selectAnexos" placeholder1="Seleccione año" placeholder2="Seleccione el trimestre" :data="anexos" @seleccionado="responseSelectComponent3 = $event" @titulo="textoTitulo3 = $event" />
                  </div>
              </div>
          </div>
          <tabla-simple id="tablaanexos" class="mt-5" :titulo="`Anexos de la Ley de Disciplina Financiera ${textoTitulo3} `" :datos="responseSelectComponent3" />
          <span v-if="responseSelectComponent3" v-html="DateFormatText(responseSelectComponent3.fecha_actualizacion)"></span>
          <span v-else v-html="DateFormatText(fecha_actualizacion_externa3)"></span>
        </div>
      </div>
  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import ArmonizacionContableSH from "@/services/ArmonizacionContable/secretariaHacienda/ArmonizacionCSHacienda.service.js";
const _serviciosArmonizacionContableSH = new ArmonizacionContableSH();
import botonAtras from '@/views/button-atras.vue'
import tablaSimple from '@/components/tablaSimple.vue';
import select2Filtros from '@/components/selectCompuesto.vue'
import { mapState } from "vuex";
import('@/assets/css/tab.css');
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
  name: "contenedorSH",
  components: { select2Filtros, tablaSimple, botonAtras },
  computed:{ ...mapState(['modoDark_var']) },
  mixins: [DateFormat],
  data() {
      return{
        itemActive1: true,
        itemActive2: false,
        itemActive3: false,

        data: [],
        disFinanciera: [],
        anexos: [],
        textoTitulo: '',
        textoTitulo2: '',
        textoTitulo3: '',

        responseSelectComponent: '',
        responseSelectComponent2: '',
        responseSelectComponent3: '',

        fecha_actualizacion_externa: '',
        fecha_actualizacion_externa2: '',
        fecha_actualizacion_externa3: ''
      }
    },
  async created() {
      await this.getSHacienda();
      await this.getSecretariaHaciendaDisciplinaFinanciera();
      await this.getSecretariaHaciendaAnexo();
  },
  methods: {
    async getSHacienda() {
          try {
              const response = await _serviciosArmonizacionContableSH.getSecretariaHacienda(mapFun.SHArmonizacionCont);

              this.data = response.data;//.reverse();
              this.fecha_actualizacion_externa = this.mixin_fecha_actual(this.data);
              this.data.forEach(e => {
                e.contenido.reverse();
              });

              this.data = this.data.map(function (e) {
                return {
                    id:                   e.id,
                    text:                 e.titulo,
                    fecha_actualizacion:  e.fecha_actualizacion,
                    seccion:              e.contenido
                };
              });

          } catch (error) {
              console.log('error', error.message);
          }
      },
      async getSecretariaHaciendaDisciplinaFinanciera() {
          try {
              const response = await _serviciosArmonizacionContableSH.getSecretariaHaciendaDisciplinaFinanciera(mapFun.SHDisciplinaFinanciera);
              // console.log(response);
              this.disFinanciera = response.data;
              this.fecha_actualizacion_externa2 = this.disFinanciera[this.disFinanciera.length-1].fecha_actualizacion;

              this.disFinanciera = this.disFinanciera.reverse();

              this.disFinanciera = this.disFinanciera.map(function (e) {
                return {
                    id:                   e.id,
                    text:                 e.titulo,
                    fecha_actualizacion:  e.fecha_actualizacion,
                    seccion:              e.contenido
                };
              });
          } catch (error) {
              console.log('error', error.message);
          }
      },
      async getSecretariaHaciendaAnexo() {
          try {
              const response = await _serviciosArmonizacionContableSH.getSecretariaHaciendaAnexo(mapFun.SHAnexo);
              // console.log(response);
              this.anexos = response.data;
              this.fecha_actualizacion_externa3 = this.anexos[this.anexos.length-1].fecha_actualizacion;


              this.anexos = this.anexos.reverse();
              this.anexos = this.anexos.map(function (e) {
                return {
                    id:                   e.id,
                    text:                 e.titulo,
                    fecha_actualizacion:  e.fecha_actualizacion,
                    seccion:              e.contenido
                };
              });
          } catch (error) {
              console.log('error', error.message);
          }
      },

    },
}

</script>
